import { render, staticRenderFns } from "./SubmitSuccess.vue?vue&type=template&id=97ed1b28&scoped=true&"
import script from "./SubmitSuccess.vue?vue&type=script&lang=js&"
export * from "./SubmitSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SubmitSuccess.vue?vue&type=style&index=0&id=97ed1b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ed1b28",
  null
  
)

export default component.exports